const developmentServer = ['local.com:9292', '127.0.0.1:9292'].some(
  (localUrl) => window.location.href.includes(localUrl)
)

if (developmentServer) {
  document.querySelector('html').classList.add('development-server')
}
